import React from "react";
import styles from "./styles/ChatThreads.module.scss";
import { CardTitle, SubTitle } from "../../Components/CustomComponents";
import { CiSearch } from "react-icons/ci";
import BorderedCard from "../../Components/Cards/BorderedCard";
import { useSocket } from "../../Context/SocketContext";
import { useSelector } from "react-redux";
import { useChatContext } from "./Context/ChatContext";
import { Spinner } from "react-bootstrap";
import _ from "lodash";

export default function ChatThreads({ setUser }) {
  const socket = useSocket();
  const isSocketConnected = useSelector((state) => state.auth.isSocketConnected);
  // const { user, isSocketConnected } = useSelector((state) => state.authInfo);
  const user = useSelector((state) => state.auth.userInfo);
  const {
    chatRoom,
    setChatRoom,
    search,
    setSearch,
    isGroup,
    handleTabChange,
    chatThreads,
    groupThread,
    resetMessageCount,
    handleAddGroup,
  } = useChatContext();

  //   console.log("chat threads", user, isSocketConnected, socket);
  //   console.log(chatThreads, chatRoom);

  const handleThreadClick = (data) => {
    if (data?.chat_room_id === chatRoom?.id) return;
    setChatRoom({
      id: data.chat_room_id,
      room_name: data.user_name || "",
      image_url: data.user_image,
    });
    resetMessageCount(data.chat_room_id);
  };

  return (
    <div className={styles.ChatThreads}>
      <div className={styles.titleContainer}>
        <SubTitle text="Messages" />
        {/* <span className={styles.searchButton}><CiSearch /></span> */}
      </div>
      <div className={styles.threads}>
        {chatThreads?.isLoading ? (
          <span className={styles.noThreads}>
            <Spinner />
          </span>
        ) : _.isEmpty(chatThreads?.data) ? (
          <p className={styles.noThreads}>Empty Inbox</p>
        ) : (
          (chatThreads?.data ?? []).map((item, index) => {
            // console.log(item);
            return (
              <div
                onClick={() => handleThreadClick(item)}
                key={item.chat_room_id ?? index}
              >
                <BorderedCard classes="my-2 overflow-visible">
                  <div className={styles.thread}>
                    <img
                      className={styles.userImage}
                      src={item.user_image || "/images/profile.png"}
                      alt="User Profile"
                    />
                    <div className={styles.userInfo}>
                      <div className={styles.nameContainer}>
                        <CardTitle text={item.user_name} classes="fs-6 lc-1" />
                        {!!item.unread_message_count ? (
                          <span className={styles.indicator}></span>
                        ) : (
                          ""
                        )}
                      </div>
                      <p className={`${styles.message} mt-1 pe-1 lc-1`}>
                        {item?.last_message?.message || ""}
                      </p>
                    </div>
                  </div>
                </BorderedCard>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
